export default "__VITE_ASSET__BZO1wOs3__"